import React, { Component, Fragment } from "reactn";
import { BlueButton, UIPane, UIPaneContents } from "js/react/components/UiComponents";
import { FlexBox, ScrollBox } from "js/react/components/LayoutGrid";
import { FlexSpacer } from "js/react/components/Gap";
import { themeColors } from "js/react/sharedStyles";
import { _ } from "js/vendor";
import { PresentationTemplateDataService } from "js/core/dataServices/PresentationTemplateDataService";
import Loadable from "js/react/components/Loadable";
import { ShowWarningDialog } from "js/react/components/Dialogs/BaseDialog";
import { PresentationTemplateItem, TemplateList } from "js/editor/TeamResources/TeamTemplatesPane";
import { NoTeamTemplateNotice } from "js/react/views/UserOptions/dialogs/NoResourcesNotices";

export class ChooseTeamTemplatePane extends Component {
    state = {
        items: [],
        isLoading: true
    }

    componentDidMount() {
        this.templatesDS = new PresentationTemplateDataService({
            onCollectionChanged: items => {
                items = _.sortBy(items, "name");
                items = items.filter(item => item.isPublished);
                this.setState({ items, isLoading: false });
            }
        });
    }

    componentWillUnmount() {
        this.templatesDS.unsubscribe();
    }

    handleClickTemplate = template => {
        this.setState({
            selectedTemplate: template
        });
    }

    handleDoubleClickTemplate = template => {
        this.setState({
            selectedTemplate: template
        });

        this.createPresentation(template);
    }

    handleClickCreatePresentation = () => {
        this.createPresentation(this.state.selectedTemplate);
    }

    createPresentation(template) {
        if (!template) {
            return ShowWarningDialog({ title: "Please select a template first." });
        }
        this.props.onCreate({ type: "team-template", template });
    }

    handleClickPalette = event => {
        this.setState({ anchorEl: event.currentTarget });
    }

    render() {
        let { isLoading, items, selectedTemplate } = this.state;

        return (
            <UIPane style={{ width: "calc(100vw - 260px)" }}>
                <UIPaneContents style={{ padding: 0, background: themeColors.lightGray }}>
                    <Loadable isLoading={isLoading}>
                        {items.length > 0 &&
                            <FlexBox vertical left fill style={{ padding: "20px 0px 20px 20px" }}>
                                <ScrollBox fill>
                                    {items.map(item =>
                                        (<PresentationTemplateItem
                                            key={item.id} item={item} readOnly
                                            selected={item == selectedTemplate}
                                            onClick={() => this.handleClickTemplate(item)}
                                            onEdit={() => this.handleDoubleClickTemplate(item)}
                                        />))}
                                </ScrollBox>
                                <FlexSpacer />
                                <FlexBox right fillWidth style={{ padding: "20px 20px 0px" }}>
                                    <BlueButton
                                        id="create-presentation-btn"
                                        onClick={this.handleClickCreatePresentation}
                                    >
                                        Create Presentation From Template
                                    </BlueButton>
                                </FlexBox>
                            </FlexBox>
                        }
                        {items.length == 0 && <NoTeamTemplateNotice/>}
                    </Loadable>
                </UIPaneContents>
            </UIPane>
        );
    }
}

